// extracted by mini-css-extract-plugin
export default {"title":"Games_title__39oD9","subtitle":"Games_subtitle__klH9E","gameList":"Games_gameList__HJD6L"};